// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_heading {
  margin: 0;
  text-align: left;
  padding: 0 1vw;
  background-image: linear-gradient(to left, #fff, #ffe169);
  color: #151042;
  position: sticky;
  top: 0px;
  z-index: 1000;
  display: flex;
  justify-content: "center";
  align-items: "center";
  flex-direction: row;
  gap: 10px;
}
@media (max-width: 1000px) {
  .main_heading {
    font-size: 1.5rem;
  }
}
@media (max-width: 600px) {
  .main_heading {
    font-size: 1.2rem;
  }
}

.loader {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #ffe169 #ffe169 transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 5vh;
}

.loader::after,
.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent transparent #ff161b #ff161b;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}

.loader::before {
  width: 50px;
  height: 50px;
  border-color: #3b00f8 #3b00f8 transparent transparent;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.table {
  width: 95vw;
  font-size: 0.9em;
  font-family: sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  margin: 2vh auto;
  table-layout: fixed;
}
.table thead {
  height: 4vh;
}
.table thead tr {
  background-color: #151042;
  color: #ffffff;
  text-align: left;
}
.table thead tr th {
  text-align: center;
}
.table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.table tbody tr:first-of-type {
  border-top: 2px solid #151042;
}
.table tbody tr:last-of-type {
  border-bottom: 2px solid #151042;
}
.table tbody tr td {
  padding: 12px 15px;
  word-wrap: break-word;
}
.table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.table tbody tr td input::-webkit-outer-spin-button,
.table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
@media (max-width: 1000px) {
  .table {
    display: block;
  }
  .table thead {
    height: 0;
    display: block;
  }
  .table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .table thead tr th {
    display: block;
  }
  .table tbody {
    display: block;
  }
  .table tbody tr {
    display: block;
    margin-bottom: 0.5vh;
    border: 1px solid #ccc;
  }
  .table tbody tr td {
    display: block;
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  .table tbody tr td:before {
    position: absolute;
    top: 10px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 700;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/reuseables.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,yDAAA;EACA,cCKe;EDJf,gBAAA;EACA,QAAA;EACA,aAAA;ECmBA,aAAA;EACA,yBDnBc;ECoBd,qBDpBwB;ECqBxB,mBAJsD;EAKtD,SALiE;ADdrE;AAFI;EAVJ;IAWQ,iBAAA;EAKN;AACF;AAJI;EAbJ;IAcQ,iBAAA;EAON;AACF;;AAJA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qDAAA;EACA,sBAAA;EACA,sCAAA;EACA,WAAA;AAOJ;;AALA;;EAEI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CAAA;EACA,+BAAA;AAQJ;;AANA;EACI,WAAA;EACA,YAAA;EACA,qDAAA;EACA,wCAAA;AASJ;;AANA;EACI;IACI,uBAAA;EASN;EAPE;IACI,yBAAA;EASN;AACF;AAPA;EACI;IACI,uBAAA;EASN;EAPE;IACI,0BAAA;EASN;AACF;AANA;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAQJ;AAPI;EACI,WAAA;AASR;AARQ;EACI,yBCzEO;ED0EP,cAAA;EACA,gBAAA;AAUZ;AATY;EACI,kBAAA;AAWhB;AALQ;EACI,gCAAA;AAOZ;AALY;EACI,yBAAA;AAOhB;AALY;EACI,6BAAA;AAOhB;AALY;EACI,gCAAA;AAOhB;AAJY;EACI,kBAAA;EACA,qBAAA;AAMhB;AALgB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAOpB;AALgB;;EAEI,wBAAA;EACA,SAAA;AAOpB;AAFI;EAnDJ;IAoDQ,cAAA;EAKN;EAHM;IACI,SAAA;IACA,cAAA;EAKV;EAJU;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAMd;EALc;IACI,cAAA;EAOlB;EAFM;IACI,cAAA;EAIV;EAHU;IACI,cAAA;IACA,oBAAA;IACA,sBAAA;EAKd;EAJc;IACI,cAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;EAMlB;EAHc;IACI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EAKlB;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.main_heading {\n    margin: 0;\n    text-align: left;\n    padding: 0 1vw;\n    background-image: linear-gradient(to left, $white, $nitrocamYellow);\n    color: $nitrocamDarkBlue;\n    position: sticky;\n    top: 0px;\n    z-index: 1000;\n    @include flex(\"center\", \"center\");\n    @media (max-width: $tablet) {\n        font-size: 1.5rem;\n    }\n    @media (max-width: $mobile) {\n        font-size: 1.2rem;\n    }\n}\n\n.loader {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    display: inline-block;\n    position: relative;\n    border: 3px solid;\n    border-color: $nitrocamYellow $nitrocamYellow transparent transparent;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n    margin: 5vh;\n}\n.loader::after,\n.loader::before {\n    content: \"\";\n    box-sizing: border-box;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    border: 3px solid;\n    border-color: transparent transparent $nitrocamRed $nitrocamRed;\n    width: 75px;\n    height: 75px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    animation: rotationBack 0.5s linear infinite;\n    transform-origin: center center;\n}\n.loader::before {\n    width: 50px;\n    height: 50px;\n    border-color: $nitrocamBlue $nitrocamBlue transparent transparent;\n    animation: rotation 1.5s linear infinite;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n@keyframes rotationBack {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(-360deg);\n    }\n}\n\n.table {\n    width: 95vw;\n    font-size: 0.9em;\n    font-family: sans-serif;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n    margin: 2vh auto;\n    table-layout: fixed;\n    thead {\n        height: 4vh;\n        tr {\n            background-color: $nitrocamDarkBlue;\n            color: #ffffff;\n            text-align: left;\n            th {\n                text-align: center;\n            }\n        }\n    }\n\n    tbody {\n        tr {\n            border-bottom: 1px solid #dddddd;\n\n            &:nth-of-type(even) {\n                background-color: #f3f3f3;\n            }\n            &:first-of-type {\n                border-top: 2px solid $nitrocamDarkBlue;\n            }\n            &:last-of-type {\n                border-bottom: 2px solid $nitrocamDarkBlue;\n            }\n\n            td {\n                padding: 12px 15px;\n                word-wrap: break-word;\n                .input_number {\n                    border-radius: 3px;\n                    border: 2px solid $nitroDark;\n                    width: 50px;\n                    height: 3vh;\n                    text-align: center;\n                }\n                input::-webkit-outer-spin-button,\n                input::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    margin: 0;\n                }\n            }\n        }\n    }\n    @media (max-width: $tablet) {\n        display: block;\n\n        thead {\n            height: 0;\n            display: block;\n            tr {\n                position: absolute;\n                top: -9999px;\n                left: -9999px;\n                th {\n                    display: block;\n                }\n            }\n        }\n\n        tbody {\n            display: block;\n            tr {\n                display: block;\n                margin-bottom: 0.5vh;\n                border: 1px solid #ccc;\n                td {\n                    display: block;\n                    border: none;\n                    border-bottom: 1px solid #eee;\n                    position: relative;\n                    padding-left: 50%;\n                }\n\n                td:before {\n                    position: absolute;\n                    top: 10px;\n                    left: 6px;\n                    width: 45%;\n                    padding-right: 10px;\n                    white-space: nowrap;\n                    font-weight: 700;\n                    text-align: left;\n                }\n            }\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
